import { footerColumns } from '@/mocks/home';

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="mx-auto w-full px-4 py-10 md:px-6 md:py-12">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50 text-primary-800">
                <i className="ri-newspaper-line text-xl" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-2xl font-black text-background-50">黑料福利</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-100/75">
              黑料福利专区导航页，聚合黑料福利入口、地址与页面板块，一个导航搞定所有通道，快速浏览各分类内容。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {['黑料福利', '黑料福利专区', '黑料福利入口', '黑料福利导航', '黑料福利地址'].map((word) => (
                <span
                  key={word}
                  className="rounded-full border border-background-50/20 px-3 py-1 text-[11px] text-background-100/80"
                >
                  {word}
                </span>
              ))}
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.id} className="lg:col-span-2">
              <h3 className="text-sm font-bold text-accent-400">{col.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#entry"
                      className="cursor-pointer text-sm text-background-100/70 transition-colors hover:text-background-50"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-1">
            <h3 className="text-sm font-bold text-accent-400">更新</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-100/70">
              <li>每日 09:00</li>
              <li>榜单 10 分钟</li>
              <li>通道周巡检</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-background-50/15 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-100/60">
            © 2026 黑料福利 · 本站为静态内容聚合展示页，所有引用的内容均标注来源与时间。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-100/60">
            <a href="#entry" className="cursor-pointer transition-colors hover:text-background-50">
              编辑准则
            </a>
            <a href="#entry" className="cursor-pointer transition-colors hover:text-background-50">
              内容标注说明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}